/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { routerAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type WithdrawLiquidityProps = {
  chainId: number
  config: Config
  routerAddress: Address
  token0Address: Address
  token1Address: Address
  stable: boolean
  sendAmount: bigint
  sendAmount0Min: bigint
  sendAmount1Min: bigint
  account: Address
  deadline: number
}

export const withdrawLiquidity = async ({
  chainId,
  config,
  routerAddress,
  token0Address,
  token1Address,
  stable,
  sendAmount,
  sendAmount0Min,
  sendAmount1Min,
  account,
  deadline,
}: WithdrawLiquidityProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: routerAbi as Abi,
        account,
        address: routerAddress,
        args: [token0Address, token1Address, stable, sendAmount, sendAmount0Min, sendAmount1Min, account, deadline],
        chainId,
        functionName: "removeLiquidity",
      },
    })
    return result
  } catch (error: any) {
    console.error("withdrawLiquidity", error)
    return { success: false, error: error.message, code: error.code }
  }
}
